import React from 'react';
import { graphql } from 'gatsby';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';

import Layout from '../components/layout';
import SEO from '../components/seo';
import { AdsProvider } from '../lib/context/ads';
import wpImageUrl from '../lib/wp-image-url';

import templateDefaultSimple from './default-simple-template-pages';
import templateNoWrapper from './nowrapper-template-pages';
import templateTMIC from './tmic-pages';
import templateUIC from './uic-pages';
import Frame from './frame';

const client = new ApolloClient<any>({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
  fetchOptions: {
    credentials: 'include',
  },
});

export interface Props {
  data: {
    wordpressPage: {
      id: number;
      date: string;
      modified: string;
      path: string;
      slug: string;
      status: string;
      type: string;
      title: string;
      content: string;
      excerpt: string;
      wordpress_id: number;
      featured_media?: {
        source_url: string;
      };
    };
  };
}

export const PageTemplate: React.FC<Props> = (props) => {
  if (!props.data) return null;

  const pagePath = props.data.wordpressPage.path;
  const featuredImage = props.data.wordpressPage.featured_media?.source_url;
  // console.log('pagePath', pagePath);

  const useSimpleTemplate = templateDefaultSimple.includes(pagePath);
  const useNoWrapperTemplate = templateNoWrapper.includes(pagePath);
  const useTMICTemplate = templateTMIC.includes(pagePath);
  const useUICTemplate = templateUIC.includes(pagePath);

  return (
    <ApolloProvider client={client as any}>
      <AdsProvider>
        <Layout
          expandedPage={useNoWrapperTemplate}
          tmic={useTMICTemplate}
          uic={useUICTemplate}
        >
          <SEO
            title={props.data.wordpressPage.title}
            description={props.data.wordpressPage.excerpt}
            image={featuredImage ? wpImageUrl(featuredImage) : undefined}
            canonicalUrl={props.data.wordpressPage.path}
          />
          {useSimpleTemplate ? (
            <>
              {featuredImage ? (
                <div
                  style={{
                    backgroundImage: `url(${wpImageUrl(featuredImage || '')})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat',
                    height: 300,
                  }}
                />
              ) : null}
              <h1
                style={{ textAlign: 'center', marginTop: '.5em' }}
                dangerouslySetInnerHTML={{
                  __html: props.data.wordpressPage.title,
                }}
              />
            </>
          ) : null}
          <Frame
            content={props.data.wordpressPage.content}
            container={useSimpleTemplate}
            tmic={useTMICTemplate}
            uic={useUICTemplate}
          />
        </Layout>
      </AdsProvider>
    </ApolloProvider>
  );
};

export default PageTemplate;

export const query = graphql`
  query($id: Int!) {
    wordpressPage(wordpress_id: { eq: $id }) {
      title
      content
      excerpt
      date(formatString: "MMMM DD, YYYY")
      modified(formatString: "MMMM DD, YYYY")
      slug
      path
      wordpress_id
      featured_media {
        source_url
      }
    }
  }
`;
